import React from "react";
import { HashRouter, Redirect, Route, Switch } from "react-router-dom";
import Fun from "./components/funComponents/Fun";
import Header from "./components/header/Header";
import About from "./pages/about/About";
import Blog from "./pages/blog/Blog";
import BlogPage from "./pages/blog/blogPage/BlogPage";
import Contact from "./pages/contact/Contact";
import Home from "./pages/home/Home";

function App() {
  return (
    <HashRouter>
      <Header />
      <main>
        <Switch>
          <Route path="/home" component={Home} />
          <Route path="/contact" component={Contact} />
          <Route path="/blogs/:blogId" component={BlogPage} />
          <Route path="/blogs" component={Blog} />
          <Route path="/about" component={About} />
          <Redirect to="/home"></Redirect>
        </Switch>
      </main>
      <Fun />
    </HashRouter>
  );
}

export default App;
